import React, { useContext } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Button, TipCard } from '../../components';
import { icons } from '../../assets';
import * as s from './styled-forgot-password-complete';
import { ThemeContext } from 'styled-components';

const RecuperarSenhaFinal = () => {

  const { colors } = useContext(ThemeContext);
  const history = useHistory();

  const onSubmit = () => {
      history.push('/login')
  };
  return (
          <s.Column>
      <TipCard icon={icons.KeyImageBackground} />
      <s.Cmodel onSubmit={onSubmit}>
        
        <s.WrapperTitle>
          <s.Label color={colors.darkblue}>Recuperar Senha</s.Label>
        </s.WrapperTitle>
        <s.Label size="18px" color={colors.label}>
        Senha cadastrada com sucesso.
        </s.Label >
        <s.ButtonContainer margin="100px 0 0 0">
          <Button
            type="submit"
            width="45vw"
            maxWidth='450px'
            label="Confirmar"
            hover
            color={colors.darkblue}
            background={colors.white}
          />
        </s.ButtonContainer> 
      </s.Cmodel>
      <div style={{width: '183px'}}></div>
    </s.Column>
  );
};

export default withRouter(RecuperarSenhaFinal);
